import type {FailedAPITaskCreationAttempt} from '@github-ui/agent-sessions/components/TaskCreationFailedBanner'
import type {CreateAPITaskParams} from '@github-ui/agent-sessions/types/api-task'
import {createContext, use} from 'react'

interface FailedTasksContextValue {
  failedTasks: FailedAPITaskCreationAttempt[]
  setFailedTasks: React.Dispatch<React.SetStateAction<FailedAPITaskCreationAttempt[]>>
  createTask: (params: CreateAPITaskParams) => void
}

const FailedTasksContext = createContext<FailedTasksContextValue | undefined>(undefined)

export function FailedTasksProvider({value, children}: {value: FailedTasksContextValue; children: React.ReactNode}) {
  return <FailedTasksContext value={value}>{children}</FailedTasksContext>
}

export function useFailedTasks() {
  const context = use(FailedTasksContext)
  if (!context) {
    throw new Error('useFailedTasks must be used within a FailedTasksProvider')
  }
  return context
}
